import { jsPDF } from 'jspdf';
import React from 'react';
import { DoctorProfile } from 'types';
import { i18nStore } from 'contexts/i18n';
import { IteroOrderAdditionalInfo } from 'components/ITeroOrderAdditionalInfo';
export { removeSpaces, isContractAvailableInCountry } from 'utils/iteroContractUtils';

export const formatIteroDateTime = () => {
  const userLocal = navigator.language;
  const formattedDate = new Date().toLocaleDateString('en-GB'); // to show date in dd/mm/yyyy format
  const formattedTime = new Date().toLocaleTimeString(userLocal, {
    timeZoneName: 'short',
  });

  return `${formattedDate} ${formattedTime}`;
};

export const addWatermark = (
  doc: jsPDF,
  version: 'ACCEPTED' | 'PREVIEW',
  doctorProfile: DoctorProfile | undefined,
  additionalOrderInfo: IteroOrderAdditionalInfo | undefined,
  localUserTime: string,
  i18n: i18nStore
) => {
  const totalPages = doc.internal.pages.length;

  const watermarkStyle = {
    align: 'right' as const,
  };
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(20);
    doc.saveGraphicsState();
    doc.setGState(doc.GState({ opacity: 0.2 }));
    doc.text(
      version,
      doc.internal.pageSize.getWidth() - 17,
      10,
      watermarkStyle
    );
    doc.setFontSize(15);
    doc.text(
      `${additionalOrderInfo?.doctorName} (${doctorProfile?.userName})`,
      doc.internal.pageSize.getWidth() - 17,
      15,
      watermarkStyle
    );
    doc.text(
      i18n['Terms & Conditions'],
      doc.internal.pageSize.getWidth() - 17,
      20,
      watermarkStyle
    );
    doc.text(
      localUserTime,
      doc.internal.pageSize.getWidth() - 17,
      25,
      watermarkStyle
    );
    doc.restoreGraphicsState();
  }
};

export const downloadPdf = async (
  version: 'ACCEPTED' | 'PREVIEW',
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  legalTextRef: React.RefObject<HTMLDivElement | null>,
  doctorProfile: DoctorProfile | undefined,
  additionalOrderInfo: IteroOrderAdditionalInfo | undefined,
  localUserTime: string,
  i18n: i18nStore
) => {
  setIsLoading(true);

  return await new Promise((resolve: (value: string) => void) => {
    const doc = new jsPDF({
      compress: true, // Enable compression
    });
    doc.setTextColor(0, 0, 0); // Set text color to black
    if (legalTextRef.current) {
      legalTextRef.current.style.maxHeight =
        legalTextRef.current.scrollHeight + 25000 + 'px'; // Set height to show all content, + 25000px to ensure all content is shown

      doc.html(legalTextRef.current, {
        margin: [20, 0, 20, 0], // Adjust your margins here
        callback: function (doc) {
          if (version === 'ACCEPTED') {
            addWatermark(
              doc,
              version,
              doctorProfile,
              additionalOrderInfo,
              localUserTime,
              i18n
            ); // Add watermark before saving
          }
          doc.setDisplayMode('fullheight', 'continuous', 'FullScreen');

          // Convert the PDF to a base64 string and strip the URI prefix
          const base64data = doc.output('dataurlstring').split(',')[1];
          resolve(base64data);

          setIsLoading(false);

          if (version === 'PREVIEW') {
            doc.save(`order_form_${version}.pdf`);
          }
          if (legalTextRef.current) {
            legalTextRef.current.style.maxHeight = '65vh'; // Reset height to default
          }
        },
        width: 200, // Adjust width to fit content within the page
        windowWidth: 1200, // Set window width to scale the content appropriately
        autoPaging: 'text', // Enable page breaks based on text content
      });
    }
  });
};
